module.exports = __webpack_public_path__ + "static/media/sitemap.8f05c0c3.svg";